import React from "react";

const SecTitle = ({ title, subTitle, titleColor, subTitleColor }) => {
  const isTailwindColor = (val) => val?.startsWith("text-");
  return (
    <>
      <div className="sec-title text-center">
        {title && (
          <h2
            className={`text-2xl lg:text-5xl font-light mb-4 leading-tight ${
              isTailwindColor(titleColor) ? titleColor : ""
            }`}
            style={!isTailwindColor(titleColor) ? { color: titleColor } : {}}
          >
            {title}
          </h2>
        )}
        {subTitle && (
          <div
            className={`sub-title text-base md:text-lg font-normal leading-relaxed max-w-3xl mx-auto ${
              isTailwindColor(subTitleColor) ? subTitleColor : ""
            }`}
            style={
              !isTailwindColor(subTitleColor) ? { color: subTitleColor } : {}
            }
          >
            <p>{subTitle}</p>
          </div>
        )}
      </div>
    </>
  );
};

export default SecTitle;
